const env = {
  apiEndpoint: "https://api.taskforce.sh/invoices/"
};

export default env;
